module.exports = __webpack_public_path__ + "static/img/ZW.20337188.svg";